import { useParams } from 'react-router-dom';

import { EditClaimForm } from './components/EditClaimForm';
import { useClaimPageQuery } from '../../hooks';

const EditClaimPage = (): JSX.Element => {
  const { claimId } = useParams();
  const { sequenceNo } = useClaimPageQuery();

  return <EditClaimForm claimId={claimId || ''} sequenceNo={sequenceNo} />;
};

export default EditClaimPage;
